import React from "react";

import TruncatedWithTooltip from "../TruncatedWithTooltip";
import { UIAvatarStack, UIStatusTag } from "../ui";
import { formatDate } from "../../utils/Helpers";

export const getClientProfileEventTypeLabel = (row, lang) =>
  row.event_type_label ||
  row.event_type?.[`name_${lang}`] ||
  row.event_type?.name ||
  row.event_type ||
  "-";

export const getClientProfileEventsColumns = ({ labels, events, lang }) => [
  {
    field: "name",
    headerName: labels.eventsColumn,
    flex: 1.4,
    minWidth: 200,
    sortable: false,
    renderCell: ({ row }) => {
      const value = row.name || "-";
      if (value === "-") {
        return <span className="MuiDataGrid-cellContent">-</span>;
      }
      return (
        <TruncatedWithTooltip title={value}>
          <span className="MuiDataGrid-cellContent">{value}</span>
        </TruncatedWithTooltip>
      );
    },
  },
  {
    field: "project_managers",
    headerName: labels.projectManagers,
    flex: 1,
    minWidth: 160,
    sortable: false,
    renderCell: ({ row }) => (
      <UIAvatarStack
        items={(row.project_managers || []).map((manager) => ({
          id: manager.admin?.id ?? manager.id,
          name: manager.admin?.name,
          image: manager.admin?.image_url,
        }))}
      />
    ),
  },
  {
    field: "event_type",
    headerName: labels.eventType,
    flex: 0.9,
    minWidth: 130,
    sortable: false,
    renderCell: ({ row }) => {
      const value = getClientProfileEventTypeLabel(row, lang);
      return (
        <TruncatedWithTooltip title={value}>
          <span className="MuiDataGrid-cellContent">{value}</span>
        </TruncatedWithTooltip>
      );
    },
  },
  {
    field: "payment_period",
    headerName: events.viewEvents.recurrency,
    flex: 0.75,
    minWidth: 120,
    sortable: false,
    renderCell: ({ row }) => (
      <div className="MuiDataGrid-cellContent">
        {row.payment_period ? (
          <UIStatusTag
            preset="table"
            status={row.payment_period}
            label={labels[row.payment_period] ?? row.payment_period}
          />
        ) : (
          "-"
        )}
      </div>
    ),
  },
  {
    field: "event_start_at",
    headerName: labels.startDate,
    flex: 0.8,
    minWidth: 130,
    sortable: false,
    renderCell: ({ row }) => (
      <span className="MuiDataGrid-cellContent mobile-style">
        {row.event_start_at ? formatDate(row.event_start_at) : "-"}
      </span>
    ),
  },
  {
    field: "event_end_at",
    headerName: labels.endDate,
    flex: 0.8,
    minWidth: 130,
    sortable: false,
    renderCell: ({ row }) => (
      <span className="MuiDataGrid-cellContent mobile-style">
        {row.event_end_at ? formatDate(row.event_end_at) : "-"}
      </span>
    ),
  },
];
